import { atom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';
import { SerializedEditorState } from 'lexical';
import { IField } from '../../../data-models/field2.data-model';
import { INoteDataModel } from '../../../data-models/note.data-model';
import { Commentary } from '../../../schemas/Commentary.schema';
import type { ActivityTabs } from '../components/ActivityDrawer/ActivityDrawer2';

export const selectedCompanyIdProfileAtom = atom<number>(-1);

export const selectedKpiChartState = atom<IField<unknown> | null>(null);

export const isDrawerOpenState = atom<boolean>(false);

export const selectedActivityTypeState = atom<ActivityTabs | undefined>(undefined);

export const selectedSummaryChartState = atom<'ttrv' | 'cumul-perf' | null>(null);

export const selectedRequestIdState = atom<number | null>(null);

export function useResetDrawerResponsesState() {
  return useAtomCallback(
    useCallback((get, set) => {
      set(selectedRequestIdState, null);
    }, [])
  );
}

export const selectedNoteStateJ = atom<INoteDataModel<SerializedEditorState> | undefined>(undefined);

export const showNoteEditorAtomJ = atom((get) => get(selectedNoteStateJ) !== undefined);

export const selectedCommentaryStateJ = atom<Commentary | undefined>(undefined);

export const showCommentaryEditorAtomJ = atom((get) => get(selectedCommentaryStateJ) !== undefined);

export enum ActivityTabsType {
  ALL = 'All activity',
  MINE = 'My Activity',
}

export const selectedActivityNotesJ = atom<ActivityTabsType>(ActivityTabsType.ALL);

// Store both name and date to match the financing round selected from the
// Financing History table (used to highlight the matching sidebar card).
export interface ISelectedDealRound {
  name: string;
  date: string;
  // Incremented each time the same round is re-clicked, so the showDealTab-off Deal Docs
  // sidebar (RoundCardV1) can re-expand a manually-collapsed round. Unused by the V2 path.
  selectionVersion?: number;
}

export const selectedDealRoundAtom = atom<ISelectedDealRound | undefined>(undefined);

// Set true briefly when the activity drawer opens from a closed state, so the Deal Docs
// sidebar (showDealTab-off V1) can apply a longer scroll-to-selected-round delay while the
// drawer mounts. Inert for the showDealTab-on path, which does not read it.
export const drawerJustOpenedAtom = atom<boolean>(false);
